// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2917":"44a61c68ed3cff3c","4044":"04ccdad3f8242705","4515":"44a61c68ed3cff3c","4969":"100f5939c9455cc5","5264":"48547af064fce775","8378":"fe7eb8d672c98daa"}[chunkId] + ".css";
};